// Import stylesheet file
import '../../styles/index.scss';
import { docReady } from '../helpers/docReady';
import { headerHeight } from './headerHeight';
docReady(function () {
    // Please only import global JS here. All other sections can be added to WebPack separarately or imported into the relevant template
    headerHeight();
});
